import useFaqState from '../../hooks/useFaqState'
import { PropsWithChildren } from 'react'
import ThreeDotsLoader from '../../../../../shared/Loaders/ThreeDotsLoader'
import { useAllCheckpointsState } from 'screens/Admin/ProjectCheckpoints/hooks/useAllCheckpointsState'
import useProjectTypesState from 'screens/Admin/ProjectTypes/hooks/useProjectTypesState'
import { useProjectStagesState } from 'screens/Admin/ProjectTypes/hooks/useProjectStagesState'

const FaqStateProvider = (props: PropsWithChildren) => {
  const { loaded: faqLoaded } = useFaqState()
  const { loading: checkpointsLoading } = useAllCheckpointsState()
  const { loading: projectTypesLoading } = useProjectTypesState()
  const { loading: projectStagesLoading } = useProjectStagesState()


  if (!faqLoaded || checkpointsLoading || projectStagesLoading || projectTypesLoading) {
    return (
      <div className='flex-page-center'>
        <ThreeDotsLoader />
      </div>
    )
  }

  return <>{props.children}</>
}

export default FaqStateProvider
